// extracted by mini-css-extract-plugin
module.exports = {"errorText":"errorText_errorText__1iPgz"};